import { Power4, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import * as SoundEffect from "../Data/SoundEffect";

export class Trailer extends PIXI.Container {
    private static readonly ANIM_KEY_DOOR: string = "animKey_Door";

    protected _wallPieces: PIXI.Sprite[];
    protected _leftSkew: number = 0;
    protected _centreSkew: number = 0;
    protected _rightSkew: number = 0;
    protected _trailerExterior: PIXI.Sprite;
    protected _trailerDoor: HLF.AnimatedSprite;

    constructor() {
        super();

        this._trailerExterior = HLF.PixiUtils.makeSprite("trailer-exterior");
        this._trailerExterior.scale.set(0.71, 0.71);
        this.addChild(this._trailerExterior);

        this._trailerDoor = new HLF.AnimatedSprite();
        this._trailerDoor.addAnimation(Trailer.ANIM_KEY_DOOR, new HLF.SpriteAnimation(
            "trailer-door-frame",
            Constants.SPRITESHEET_DOOR_SEQUENCE,
            3, 4, 6, false,
        ));
        this._trailerDoor.position.set(-45, -12);
        this._trailerDoor.holdFrame(Trailer.ANIM_KEY_DOOR);
        this._trailerExterior.addChild(this._trailerDoor);

        this._wallPieces = new Array<PIXI.Sprite>();
        this._wallPieces.push(HLF.PixiUtils.makeSprite("studio-wall-centre-frame0000"));
        this._wallPieces.push(HLF.PixiUtils.makeSprite("studio-wall-side-frame0000"));
        this._wallPieces.push(HLF.PixiUtils.makeSprite("studio-wall-side-frame0000"));

        for (let index = 0; index < this._wallPieces.length; index++) {
            const element = this._wallPieces[index];
            this.addChild(element);
        }

        this._wallPieces[0].anchor.set(0.5, 1);
        this._wallPieces[0].position.set(0, 461);
        this._wallPieces[1].anchor.set(0, 1);
        this._wallPieces[1].position.set(-this._wallPieces[0].width * 0.5 - this._wallPieces[1].width * 0.80, 407);
        this._wallPieces[2].anchor.set(1, 1);
        this._wallPieces[2].position.set(this._wallPieces[0].width * 0.5 + this._wallPieces[2].width * 0.80, 407);
    }

    public update(pDeltaTime: number) {
        if (this._trailerDoor !== undefined) {
            this._trailerDoor.update(pDeltaTime);
        }
    }

    public playWallAnimation(): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        timeline.to(this, 1.5, {
            _centreSkew: -0.6,
            ease: Power4.easeIn,
        }, 0);
        timeline.to(this, 1.5, {
            _leftSkew: 0.1,
            ease: Power4.easeIn,
        }, 0.1);
        timeline.to(this, 1.5, {
            _rightSkew: 0.1,
            ease: Power4.easeIn,
        }, 0.2);
        timeline.to(this._wallPieces[0].scale, 1.5, {
            y: 0.28,
            ease: Power4.easeIn,
            onComplete: () => PubSub.publishSync(HLF.PLAY_AUDIO, new HLF.AudioToken(
                SoundEffect.WALL1_IMPACT, 1, false, HLF.AudioCategory.SFX),
            ),
        }, 0);
        timeline.to(this._wallPieces[1].scale, 1.5, {
            y: 0.2,
            ease: Power4.easeIn,
            onComplete: () => PubSub.publishSync(HLF.PLAY_AUDIO, new HLF.AudioToken(
                SoundEffect.WALL2_IMPACT, 1, false, HLF.AudioCategory.SFX),
            ),
        }, 0.1);
        timeline.to(this._wallPieces[2].scale, 1.5, {
            y: 0.2,
            ease: Power4.easeIn,
            onComplete: () => PubSub.publishSync(HLF.PLAY_AUDIO, new HLF.AudioToken(
                SoundEffect.WALL3_IMPACT, 1, false, HLF.AudioCategory.SFX),
            ),
        }, 0.2);

        timeline.eventCallback(Constants.TWEEN_ONUPDATE, () => {
            this._wallPieces[0].skew.set(this._centreSkew, 0);
            this._wallPieces[1].skew.set(this._leftSkew, 0);
            this._wallPieces[2].skew.set(this._rightSkew, 0);
        });

        return timeline;
    }

    public playDoorAnim(): void {
        this._trailerDoor.play(Trailer.ANIM_KEY_DOOR);
        new TimelineLite().call(() => {
            PubSub.publishSync(HLF.PLAY_AUDIO, new HLF.AudioToken(
                SoundEffect.DOOR_OPEN,
                1, false, HLF.AudioCategory.SFX,
            ));
        }, undefined, undefined, 0.25);
    }
}
